"use client";

import { scheduleDailyPuzzleReturnClearOnLeave } from "@/lib/daily-puzzle/return-path";
import { useEffect } from "react";

/** Drop the Daily Puzzle return marker when this game visit ends (Back, header nav, unmount). */
export function useClearDailyPuzzleReturnOnLeave(slug: string): void {
  useEffect(() => scheduleDailyPuzzleReturnClearOnLeave(slug), [slug]);
}
